// START_MODULE components_atoms_icons_meetingicon_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';

import { IconProps } from './interfaces/iconProps';

const MeetingIcon: React.FC<IconProps> = ({ size = 64, color = 'currentColor', ...restProps }) => (
  <svg {...restProps} fill={color} height={`${size}px`} width={`${size}px`} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" xmlSpace="preserve">
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <circle cx="31.89" cy="22.71" r="5.57" />
      <path d="M43.16,43.74A11.28,11.28,0,0,0,31.89,32.47h0A11.27,11.27,0,0,0,20.62,43.74Z" />
      <circle cx="48.46" cy="22.71" r="5.57" />
      <path d="M46.87,43.74H59.73A11.27,11.27,0,0,0,48.46,32.47h0a11.24,11.24,0,0,0-5.29,1.32" />
      <circle cx="15.54" cy="22.71" r="5.57" />
      <path d="M17.13,43.74H4.27A11.27,11.27,0,0,1,15.54,32.47h0a11.24,11.24,0,0,1,5.29,1.32" />
    </g>
  </svg>
);

export default MeetingIcon;

// END_MODULE components_atoms_icons_meetingicon_tsx
